export const updateTravelSupplement = (state, value, direction) => {
    if (value === 'both') {
        return state.set('inboundTravelSupplement', parseFloat(value)).set('outboundTravelSupplement', parseFloat(value));
    }
    return direction === 'outbound' ? state.set('outboundTravelSupplement', parseFloat(value)) : state.set('inboundTravelSupplement', parseFloat(value));
};

export const setTravelWanted = (state, travelWanted) => {
    return state.set('travelWanted', travelWanted);
};

export const setQuoteWanted = (state, quoteWanted) => {
  return state.set('quoteWanted', quoteWanted);
};
